import { FormattedMessage } from 'react-intl';
import { useWatch } from 'react-hook-form';
import { Box } from '@mui/material';
import ReactHookFormField from 'components/ReactHookFormField';
import { pdpTexts } from 'i18n';
import EnergyLevelSmileIcon from '../EnergyLevelSmileIcon.component';

export default function EnergyLevelField() {
  const energyLevelOptions = Array.from({ length: 10 }, (_, index) => ({
    id: index + 1,
    name: `${index + 1}`,
  }));

  const currentEnergyLevel = useWatch({ name: 'currentEnergyLevel' }) as
    | number
    | undefined;

  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 2 }}>
      <Box sx={{ flex: 1 }}>
        <ReactHookFormField
          name="currentEnergyLevel"
          type="select"
          label={<FormattedMessage {...pdpTexts.currentEnergyLevel} />}
          options={energyLevelOptions}
          fieldProps={{
            size: 'medium',
          }}
        />
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: '9px',
          minWidth: '24px',
        }}
      >
        <EnergyLevelSmileIcon energyLevel={currentEnergyLevel} />
      </Box>
    </Box>
  );
}
